<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="memberFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                memberFileForm: () => import('../forms/MemberFileForm'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: 'Created At', value: 'createdAt', format: this.formatDateTime },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "createdAt", direction: "descending" },
                    { column: "memberId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'memberFiles',
                editPageName: 'memberFile',
                apiMethod: 'MemberFiles',
                claimName: 'MemberFiles',
                formTitle: 'Member File',
                excelTitle: 'Member Files',
                hasEditPage: false,
            }
        },
    };
</script>
